exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face {\r\n  font-family: 'Material Icons';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src: local('Material Icons'), local('MaterialIcons-Regular'),\r\n  url(" + require("../fonts/materialicons.woff2") + ") format('woff2'),\r\n  url(" + require("../fonts/materialicons.woff") + ") format('woff');\r\n}\r\n.material-icons {\r\n  font-family: 'Material Icons';\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  font-size: 24px;\r\n  line-height: 1;\r\n  letter-spacing: normal;\r\n  text-transform: none;\r\n  display: inline-block;\r\n  word-wrap: normal;\r\n\r\n  font-feature-settings: 'liga';\r\n  -webkit-font-feature-settings: 'liga';  \r\n  -webkit-font-smoothing: antialiased;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/css/materialicons.css
// module id = 196
// module chunks = 0